import { FiEdit2 } from "react-icons/fi";
import { useContext, useEffect, useState } from "react";
import { DataProvider } from "../../store/ContextProvider";
import { fetchCandidateExperience } from "../../services/Candidate Portal/Profile/fetchCandidateDetails";
import work from '../../assets/CandidateProfile/work.svg'
import { BsDot } from "react-icons/bs";
import { formatMonth, renderExpDuration } from "../../utils/Candidate Portal/ExperiencesList";
import { useLocation, useNavigate } from "react-router-dom";

function Experience({ candidate, currentUser }) {

    const { BeURL } = useContext(DataProvider)
    const [experiences, setExperinces] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerpage] = useState(5);
    const [totalPage, setTotalPage] = useState(0);
    const [totalExperience, setTotalExperience] = useState(0)

    const location = useLocation()

    useEffect(() => {
        const fetchExperience = async () => {
            await fetchCandidateExperience(BeURL, candidate._id, currentPage, rowsPerPage, setTotalExperience, setTotalPage, setExperinces)
        }
        fetchExperience()
    }, [currentPage, rowsPerPage, BeURL])

    useEffect(() => {
        setCurrentPage(1)
    }, [rowsPerPage])


    const handlePagination = (dir) => {
        if (dir === 'prev' && currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && currentPage < totalPage) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const formatNames = values => {
        if (values) {
            return values?.split(/[_-\s]/)?.map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');
        }
        else return " - "
    }

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const navigate = useNavigate()
    return (
        <div className="bg-white rounded-xl shadow-md p-4 sm:p-5 md:p-6 lg:p-8 xl:p-10 max-w-full mx-auto">
            {/* */}
            <div className="flex justify-between items-center"><h3 className="font-semibold text-lg md:text-xl mt-4"> Experiences</h3>
                {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500 text-xl font-bold" onClick={() => navigate(`/update-account/experience?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname, active: 'Experience' } })} />}</div>

            <div className="flex flex-col gap-4 my-4 ">
                {experiences?.length > 0 ? (
                    experiences.map((exp, i) => {
                        // split description into bullet points
                        const points =
                            exp?.description
                                ?.split(".")
                                .map((p) => p.trim())
                                .filter((p) => p.length > 0) || [];

                        return (
                            <div
                                key={i}
                                className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-5 px-3 sm:px-4 md:px-5 py-4 shadow-md rounded-lg "
                            >
                                {/* Left side */}
                                <div className="flex flex-col sm:flex-row gap-4 items-start">
                                    <img
                                        src={work}
                                        alt="work"
                                        className=" sm:w-12 sm:h-12  object-contain md:pt-5"
                                    />
                                    <div className="flex flex-col">
                                        {exp?.jobTitle && (
                                            <div className="text-base sm:text-lg  font-semibold text-black flex flex-wrap gap-2 items-center">
                                                <p>{formatNames(exp.jobTitle)}</p>
                                                <p className="text-primary-400 bg-blue-200 rounded-lg px-2 text-sm flex items-center gap-1 font-normal">
                                                    {formatNames(exp?.employmentType)} <BsDot />
                                                    {exp?.workMode ? formatNames(exp?.workMode) : ''}
                                                </p>
                                            </div>
                                        )}

                                        {exp?.employer && (
                                            <p className="text-gray-700 font-medium text-sm ">
                                                {formatNames(exp.employer)},{exp?.city},{exp?.state}
                                            </p>
                                        )}

                                        <div className="text-gray-500 text-sm ">
                                            {exp?.periodFrom && (
                                                <span>
                                                    {formatMonth(
                                                        new Date(exp.periodFrom).toLocaleDateString(), months
                                                    )}
                                                </span>
                                            )}
                                            {exp?.periodTo ? (
                                                <span>
                                                    {" "}
                                                    -{" "}
                                                    {formatMonth(
                                                        new Date(exp.periodTo).toLocaleDateString(), months
                                                    )}
                                                </span>
                                            ) : (
                                                <span>
                                                    {" "}
                                                    - {renderExpDuration(exp.periodFrom, exp.periodTo, exp.isOngoing)}
                                                </span>
                                            )}
                                        </div>
                                        {!exp.isOngoing && <span className="text-gray-500 text-sm sm:text-base">{renderExpDuration(exp.periodFrom, exp.periodTo, exp.isOngoing)}</span>}

                                        {/* Bullet list */}
                                        {points.length > 0 && (
                                            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700 text-sm sm:text-base">
                                                {points.map((p, idx) => (
                                                    <li key={idx}>{p}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="text-center my-3">No Data Available!</p>
                )}
            </div>

            {/* Pagination */}
            <div>
                <div className="mx-auto mt-7 flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-3">
                    <div className="flex items-center gap-2">
                        <label htmlFor="recordsPerPage" className="text-sm">
                            Records per page:
                        </label>
                        <select
                            id="recordsPerPage"
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerpage(parseInt(e.target.value, 10))}
                            className="ml-2 px-3 py-1 border rounded text-sm"
                        >
                            {[5, 10, 25, 50, 75, 100].map((n) => (
                                <option key={n} value={n}>
                                    {n}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="text-sm">Total Experiences: {totalExperience}</div>
                </div>

                <div className="flex justify-center items-center gap-4 mt-4">
                    <span
                        className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${currentPage === 1 ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                            }`}
                        onClick={() => handlePagination("prev")}
                    >
                        chevron_left
                    </span>
                    <span className="text-sm md:text-base">
                        {currentPage} of {totalPage}
                    </span>
                    <span
                        className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${currentPage === totalPage
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                            }`}
                        onClick={() => handlePagination("next")}
                    >
                        chevron_right
                    </span>
                </div>
            </div>
        </div>
    )
}


export default Experience